<template>
  <section>
    <div class="furniture">
      <img
        src="Furniture.png"
        alt="Furniture"
        loading="eager"
        decoding="async"
      />
      <p>
        Sed ut perspiciatis unde omnis natus error sit voluptatem accusantium
        doloremque.
      </p>
      <router-link to="/furniture">
        <button>Furniture</button>
      </router-link>
    </div>
    <div class="lighting">
      <img src="Lighting.png" alt="Lighting" loading="eager" decoding="async" />
      <p>
        Sed ut perspiciatis unde omnis natus error sit voluptatem accusantium
        doloremque.
      </p>
      <router-link to="/lighting">
        <button>Lighting</button>
      </router-link>
    </div>
    <div class="rug">
      <img src="Rugs.png" alt="Rug" loading="eager" decoding="async" />
      <p>
        Sed ut perspiciatis unde omnis natus error sit voluptatem accusantium
        doloremque.
      </p>
      <router-link to="/rug">
        <button>Rugs</button>
      </router-link>
    </div>
  </section>
</template>

<style lang="scss" scoped>
section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  margin: auto;
  margin-bottom: 4rem;
  width: 80%;
}

.furniture,
.lighting,
.rug {
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 24px;
  padding-right: 24px;
  align-self: flex-start;
  border-width: 0;
  border-style: solid;

  p {
    text-align: center;
    font-family: "Poppins", sans-serif;
    color: #2b2b2b;
    text-transform: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  a {
    text-decoration: none;

    button {
      display: flex;
      font-size: 1em;
      justify-content: center;
      align-items: center;
      margin-left: auto;
      margin-right: auto;
      padding: 0.5em 1em;
      text-align: center;
      white-space: normal;
      word-break: break-word;
    }

    button {
      color: #fff;
      background-color: #32373c;
      box-shadow: none;
      border-radius: 0px;
      border: 0px;
      height: 45px;
      width: 120px;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 700px) {
  section {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: 1fr;
    margin: auto;
    margin-bottom: 4rem;
    width: 80%;
  }
}
</style>
